module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/contract/contract-signature/contract-signature.scss
// module id = ./web/modern/components/contract/contract-signature/contract-signature.scss
// module chunks = 0